/**
 * The stored percentile is PERCENT_RANK, which is 0 for first place, so ranks 1-10 get a rank band.
 * @param {number} rank
 * @param {number} percentile
 */
export function rankLabel(rank, percentile) {
	if (rank <= 1) return "Winner";
	if (rank <= 10) return "Top 10";
	return `Top ${percentile < 1 ? 1 : percentile}%`;
}

/**
 * Reads the raw percentile so the tier matches what usp_GiveTrophies awarded.
 * @param {number} rank
 * @param {number} percentile
 */
export function tierFor(rank, percentile) {
	if (rank <= 1) return "diamond";
	if (rank <= 10) return "platinum";
	if (percentile <= 10) return "gold";
	if (percentile <= 30) return "silver";
	if (percentile <= 50) return "bronze";
	return "wood";
}
